import React from "react";
import { connect } from "react-redux";
import Link from "../fm/lib/Link";
import { formatDate } from "../fm/lib/util";
import { Img } from "../fm/field";
import { entityFields } from "../fm/conf/entity";
import { toggle } from "../fm/reducers/page";

const DocRowRenderer = ({ entity, index }) => {
  let th = entity.thumb;
  if (!th && entity.bundle) {
    //console.log(entity, entityFields);
    const thumbs = entityFields[entity.bundle].filter(
      field => field.name === "thumb"
    );
    if (thumbs.length > 0 && thumbs[0].default)
      th = [{ url: thumbs[0].default }];
  }

  return (
    <div className={"row " + (index % 2 ? "even" : "odd")}>
      {th && (
        <Link to={entity.path} className="thumb">
          <Img src={th} imageStyle="thumb" />
        </Link>
      )}
      <div className="text">
        <div className="date">{formatDate(entity.date, "ro")}</div>
        <Link to={entity.path} className="title">
          <h3>{entity.title}</h3>
        </Link>
      </div>
      {entity.project === 1 && (
        <img
          src="https://scoalalacrima.ro/img/pocu.svg"
          className="pocuimg"
          alt="POCU"
        />
      )}
      {entity.project === 2 && (
        <img
          src="https://scoalalacrima.ro/img/erasmus.svg"
          className="erasmusimg"
          alt="ERASMUS"
        />
      )}
    </div>
  );
};

const RealTeamRowRenderer = ({ entity, index, toggle }) => (
  <div className={"row " + (index % 2 ? "even" : "odd")} onClick={toggle}>
    {entity.img && <Img src={entity.img} />}
    <div className="text">
      <h3>
        {entity.first_name}{" "}
        <span className="last-name">{entity.last_name}</span>
      </h3>
      {entity.position && <div className="position">{entity.position}</div>}
      <div className="details">Detalii</div>
    </div>
  </div>
);

const TeamRowRenderer = connect(
  null,
  (dispatch, { view, index }) => ({
    toggle: e => dispatch(toggle("personDetails", { view, index }))
  })
)(RealTeamRowRenderer);

const VideoRenderer = ({ view, viewData }) => (
  <div className="view">
    {view.title && <h2 className="title">{view.title}</h2>}
    {view.moreText && view.moreLink && (
      <Link to={view.moreLink} className="more-link">
        {view.moreText}
      </Link>
    )}
    <div className="view-content">
      {viewData.data.map((entity, i) => (
        <div key={i} className="row">
          <Link to={entity.path} className="title">
            <h3>{entity.title}</h3>
          </Link>
          {entity.thumb && (
            <Link to={entity.path} className="thumb">
              <Img src={entity.thumb} imageStyle="thumb" />
            </Link>
          )}
        </div>
      ))}
    </div>
  </div>
);

const EvRenderer = ({ view, viewData }) => (
  <div className="view">
    {view.title && <h2 className="title">{view.title}</h2>}
    {view.moreText && view.moreLink && (
      <Link to={view.moreLink} className="more-link">
        {view.moreText}
      </Link>
    )}
    <div className="view-content">
      {viewData.data.map((entity, i) => (
        <div key={i} className="row">
          {entity.thumb && (
            <Link to={entity.path} className="thumb">
              <Img src={entity.thumb} imageStyle="thumb" />
            </Link>
          )}
          <Link to={entity.path} className="title">
            <h3>{entity.title}</h3>
          </Link>
        </div>
      ))}
    </div>
  </div>
);

const LinkRenderer = ({ view, viewData }) => (
  <div className="view">
    {view.title && <h2 className="title">{view.title}</h2>}
    <div className="more-link">&nbsp;</div>
    <ul className="view-content">
      {viewData.data.map((entity, i) => (
        <li key={i} className="row">
          <Link to={entity.link.path} className="title">
            <h3>{entity.link.label}</h3>
          </Link>
        </li>
      ))}
    </ul>
  </div>
);

const PocuRowRenderer = ({ entity, index }) => {
  return (
    <div className={"row " + (index % 2 ? "even" : "odd")}>
      <div className="text">
        <div className="date">{formatDate(entity.date, "ro")}</div>
        <Link to={entity.path} className="title">
          <h3>{entity.title}</h3>
        </Link>
      </div>
    </div>
  );
};

const ErasmusRowRenderer = ({ entity, index }) => {
  return (
    <div className={"row " + (index % 2 ? "even" : "odd")}>
      <div className="text">
        <div className="date">{formatDate(entity.date, "ro")}</div>
        <Link to={entity.path} className="title">
          <h3>{entity.title}</h3>
        </Link>
      </div>
    </div>
  );
};

const renderers = {
  docRow: DocRowRenderer,
  teamRowRenderer: TeamRowRenderer,
  videoRenderer: VideoRenderer,
  evRenderer: EvRenderer,
  linkRenderer: LinkRenderer,
  PocuRowRenderer,
  ErasmusRowRenderer
};
export default renderers;



// WEBPACK FOOTER //
// ./src/components/Views.js